export const DOSSIER_ATTACHMENTS_RESOURCE = {
  key: 'DOSSIER_ATTACHMENTS_RESOURCE',
  table: {
    defaultSort: 'name',
    dataLocation: '_embedded.resourceList',
    dataTransform: (data) =>
      data?.map((i) => ({
        ...i
      })),
    fields: [
      { value: 'name', label: 'Naam', show: true, order: 0 },
      { value: 'description', label: 'Beschrijving', show: true, order: 1 }
    ]
  },
  api: {
    get: () => {
      throw new Error('Replace api.get for DOSSIER_ATTACHMENTS_RESOURCE');
    }
  }
};
